import CryptoJS from "crypto-js";
import { REACT_APP_VOUCHER_ENCRYPTION_KEY } from "shared/config";

export const encryptVoucher = (voucher: string): string => {
  return CryptoJS.AES.encrypt(voucher, REACT_APP_VOUCHER_ENCRYPTION_KEY, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decryptVoucher = (ciphertext: string): string => {
  const decryptedBytes = CryptoJS.AES.decrypt(
    ciphertext,
    REACT_APP_VOUCHER_ENCRYPTION_KEY
  );
  return decryptedBytes.toString(CryptoJS.enc.Utf8);
};
